import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles, BatteryCharging, Repeat } from 'lucide-react';
export function Pillars() {
  const pillars = [{
    icon: Sparkles,
    title: 'Simplicidad',
    desc: 'No necesitás cien recetas. Necesitás unas pocas recetas buenas que puedas repetir.',
    color: 'bg-amber-100 text-amber-600'
  }, {
    icon: BatteryCharging,
    title: 'Saciedad',
    desc: 'Cada comida debe ayudarte a sentirte satisfecha. Priorizamos proteínas, verduras y alimentos reales.',
    color: 'bg-emerald-100 text-emerald-600'
  }, {
    icon: Repeat,
    title: 'Consistencia',
    desc: 'No buscamos perfección. Buscamos repetir hábitos simples durante 30 días. Si un día te salís del plan, simplemente continuá.',
    color: 'bg-brand-100 text-brand-600'
  }];
  return <section className="py-20 bg-stone-900 text-white" data-id="element-188">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-189">
        <FadeIn data-id="element-190">
          <div className="text-center mb-16 max-w-2xl mx-auto" data-id="element-191">
            <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6" data-id="element-192">
              Los 3 Pilares del Método
            </h2>
            <p className="text-stone-400 text-lg" data-id="element-193">
              Este método funciona porque elimina la fricción. Si una comida
              saludable es fácil, la repetís. Si es complicada, la abandonás.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-194">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <FadeIn key={i} delay={i * 0.15} direction="up" data-id="element-195">
                <div className="bg-stone-800/50 border border-stone-700 p-8 rounded-3xl h-full hover:bg-stone-800 transition-colors" data-id="element-196">
                  <div className={`w-14 h-14 rounded-2xl ${pillar.color} flex items-center justify-center mb-6`} data-id="element-197">
                    <Icon className="w-7 h-7" data-id="element-198" />
                  </div>
                  <h3 className="text-2xl font-heading font-bold mb-4" data-id="element-199">
                    {pillar.title}
                  </h3>
                  <p className="text-stone-400 leading-relaxed" data-id="element-200">
                    {pillar.desc}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}